import Component from './components/Providers';
import { PATH } from './constants';

export { PATH };
export default Component;
